import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'next/router'
import {
  Facebook,
  Twitter,
  WhatsApp,
  Viber,
  Email,
  Telegram
} from 'src/modules/layout/Sidebar/shared/components/SocServices'
import { getCurrentAd } from 'src/modules/ads/detail/selectors'
import config from 'SRC/config/config.json'

const Share = ({ router, ad }) => {
  const asPath = router.asPath
  const link = ad && ad.link ? ad.link : null
  const baseUrl = link
    ? link.startsWith('http')
      ? ''
      : config.deepLinkUrl
    : config.siteUrl

  console.log('baseUrl', baseUrl)
  console.log('link', link)
  return <div className='oglasi-share'>
    <Facebook asPath={asPath} adLink={link} baseUrl={baseUrl} />
    <Twitter asPath={asPath} adLink={link} baseUrl={baseUrl} />
    <WhatsApp asPath={asPath} adLink={link} baseUrl={baseUrl} />
    <Viber asPath={asPath} adLink={link} baseUrl={baseUrl} />
    <Email asPath={asPath} adLink={link} baseUrl={baseUrl} />
    <Telegram asPath={asPath} adLink={link} baseUrl={baseUrl} />
  </div>
}

Share.propTypes = {
  router: PropTypes.shape({
    asPath: PropTypes.string.isRequired
  }),
  ad: PropTypes.shape({
    link: PropTypes.string.isRequired
  })
}

export default compose(connect(state => ({ ad: getCurrentAd(state) })), withRouter)(Share)
